import React from 'react';

interface ActionBarProps {
  callCheckLabel: string;
  onCall: () => void;
  onRaise: () => void;
  onFold: () => void;
  canStraddle: boolean;
  straddleLabel: string;
  onStraddle: () => void;
}

/**
 * Generic action bar used on each street.
 * Handles Call/Check, Raise, Straddle (optional), and Fold buttons.
 */
const ActionBar: React.FC<ActionBarProps> = ({
  callCheckLabel,
  onCall,
  onRaise,
  onFold,
  canStraddle,
  straddleLabel,
  onStraddle,
}) => {
  return (
    <div className="street-action-row">
      <button className="action-btn call" type="button" onClick={onCall}>
        {callCheckLabel}
      </button>
      <button className="action-btn raise" type="button" onClick={onRaise}>
        Raise
      </button>
      <button className="action-btn fold" type="button" onClick={onFold}>
        Fold
      </button>
      <div style={{ width: 0, flex: '1 0 0', display: 'flex', justifyContent: 'center' }}>
        {canStraddle ? (
          <button className="action-btn straddle" type="button" onClick={onStraddle}>
            {straddleLabel}
          </button>
        ) : (
          <button className="action-btn straddle" type="button" disabled aria-hidden="true" style={{ visibility: 'hidden' }}>
            {straddleLabel}
          </button>
        )}
      </div>
    </div>
  );
};

export default ActionBar; 